<div class="name-cell" (click)="onClick()">
    <user-avatar
        [name]="name"
        [src]="avatarUrl"
        [alt]="name"
        [size]="40"
    ></user-avatar>
    <div class="name-text">
        <div class="name-title">{{ name }}</div>
        <div class="name-email">{{ email }}</div>
    </div>
</div>
